"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCloudinaryQuality = void 0;
var parseCloudinaryQuality = function (imageSrc, termToAdd) {
    if (!imageSrc) {
        return null;
    }
    if (imageSrc.includes('cloudinary.com')) {
        var terms = [];
        if (!imageSrc.includes('q_auto,f_auto')) {
            terms = ['q_auto,f_auto'];
            if (termToAdd) {
                terms = __spreadArray(__spreadArray([], __read(terms)), __read(termToAdd));
            }
        }
        else {
            if (termToAdd) {
                terms = __spreadArray([], __read(termToAdd));
            }
        }
        var termsQuery = terms.join('/');
        var searchTermUpload = 'upload/';
        var searchTermUploadIndex = imageSrc.indexOf(searchTermUpload);
        if (searchTermUploadIndex >= 0) {
            return "" + imageSrc.slice(0, searchTermUploadIndex + searchTermUpload.length) + termsQuery + "/" + imageSrc.slice(searchTermUploadIndex + searchTermUpload.length);
        }
        var searchTermFetch = 'fetch/';
        var searchTermFetchIndex = imageSrc.indexOf(searchTermFetch);
        if (searchTermFetchIndex >= 0) {
            return "" + imageSrc.slice(0, searchTermFetchIndex + searchTermFetch.length) + termsQuery + "/" + imageSrc.slice(searchTermFetchIndex + searchTermFetch.length);
        }
    }
    return imageSrc;
};
exports.parseCloudinaryQuality = parseCloudinaryQuality;
//# sourceMappingURL=StringHelper.js.map